import { useEffect, useState } from "react";
import { BiArrowFromBottom } from "react-icons/bi";

import classNames from "classnames";

export const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  return (
    <div className="fixed bottom-2 right-2 z-20">
      <button
        type="button"
        onClick={scrollToTop}
        className={classNames(
          isVisible ? "block" : "hidden",
          "bg-red-600 dark:bg-green-800 hover:bg-red-700 dark:hover:bg-green-900  inline-flex items-center rounded-full p-3 text-white shadow-sm transition-opacity"
        )}
        aria-hidden="true"
      >
        <BiArrowFromBottom className="h-6 w-6" aria-hidden="true" />
      </button>
    </div>
  );
};
